import Layout from "../components/Layout";
import { Reveal } from "../components/Reveal";
import { Eyebrow, PageHeader } from "../components/bits";
import { Table, Radio, ChefHat, Building2, Laptop } from "lucide-react";

const TIMELINE = [
  { icon: Table, label: "Surfaces", note: "Desks & counters charge through the wood" },
  { icon: Radio, label: "Rooms", note: "Ambient top-up, everywhere in between" },
  { icon: ChefHat, label: "Kitchen", note: "Cordless, battery-free Ki appliances" },
  { icon: Building2, label: "Venues", note: "Charging as an amenity, everywhere you go" },
  { icon: Laptop, label: "Revo-native devices", note: "The first products with no charging port" },
];

export default function About() {
  return (
    <Layout>
      <PageHeader
        eyebrow="About"
        title="Why we're building ChargeRevo."
      />

      <section className="bg-white px-5 pb-16 md:px-8">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <div className="space-y-6 text-xl leading-relaxed text-navy/80">
              <p>
                Every technology in your life went wireless — your calls, your internet, your music, your keys. Power never did. We kept buying the same cables, hunting the same outlets, and babysitting the same batteries, because charging was always sold as hardware.
              </p>
              <p>
                ChargeRevo was founded on a different idea: <span className="font-semibold text-navy">charging is a utility, and utilities are services.</span> We don't sell you a charger. We make charging something you never think about again.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* FOUNDER */}
      <section className="bg-revo-surface px-5 py-20 md:px-8">
        <div className="mx-auto grid max-w-4xl items-center gap-10 sm:grid-cols-[auto_1fr]">
          <Reveal>
            <div className="flex h-40 w-40 items-center justify-center rounded-3xl bg-navy">
              <span className="font-display text-5xl font-black text-revo-green">DJ</span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <Eyebrow dark>Founder</Eyebrow>
            <h2 className="mt-2 font-display text-3xl font-black tracking-tight text-navy">DJ Jaiyesimi</h2>
            <p className="mt-4 text-lg leading-relaxed text-navy/70">
              A 20-year veteran of enterprise technology transformation. ChargeRevo is patent-pending on the cloud systems that make subscription charging possible. We publish what our hardware can and cannot do — we think that's why you'll trust us with something as fundamental as power.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ROAD AHEAD */}
      <section className="relative overflow-hidden bg-navy px-5 py-24 md:px-8 grain">
        <div className="mx-auto max-w-6xl">
          <Reveal><Eyebrow>The road ahead</Eyebrow><h2 className="mt-3 font-display text-3xl font-black tracking-tight text-white sm:text-4xl">From surfaces to a world with no ports.</h2></Reveal>
          <div className="mt-14 grid gap-8 sm:grid-cols-3 lg:grid-cols-5">
            {TIMELINE.map((t, i) => (
              <Reveal key={t.label} delay={i * 0.1}>
                <div className="relative">
                  <span className="font-display text-sm font-bold text-revo-ice/40">0{i + 1}</span>
                  <span className="mt-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-revo-green/15 text-revo-green"><t.icon className="h-6 w-6" /></span>
                  <h3 className="mt-4 font-display text-lg font-extrabold text-white">{t.label}</h3>
                  <p className="mt-1 text-sm text-revo-ice/60">{t.note}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
